import { defineMessages } from 'react-intl';

const scope = 'app.hooks.messages';

export default defineMessages({
  dontShowAgain: {
    id: `${scope}.dontShowAgain`,
    defaultMessage: "Don't show this again",
  },
  gotIt: {
    id: `${scope}.gotIt`,
    defaultMessage: 'Got it',
  },
});
